import { DateInput } from '@components/index';
import { memo } from 'react';
import { InputList, BigInputDiv, GlobalHeader } from '../styles';
import { PropsInputGlobal } from './types';
import { onChangeGlobal, setForAllNew } from './utils';

type LicenseGroupProps = PropsInputGlobal<
  'licenseStartDate' | 'licenseEndDate'
>;

export function LicenseGroup(props: LicenseGroupProps) {
  const { setFormV, licenseEndDate, licenseStartDate, setGlobalFormV } = props;

  return (
    <InputList>
      <BigInputDiv>
        <GlobalHeader>License Start Date</GlobalHeader>
        <DateInput
          borderColor="#d8dae5"
          value={licenseStartDate ?? null}
          handleDateChange={e => {
            let convDate: Date | null = null;
            if (e) convDate = new Date(e);
            onChangeGlobal('licenseStartDate', convDate, setGlobalFormV);
            setForAllNew('licenseStartDate', convDate, setFormV);
          }}
        />
      </BigInputDiv>
      <BigInputDiv>
        <GlobalHeader>License End Date</GlobalHeader>
        <DateInput
          borderColor="#d8dae5"
          value={licenseEndDate ?? null}
          handleDateChange={e => {
            let convDate: Date | null = null;
            if (e) convDate = new Date(e);

            onChangeGlobal('licenseEndDate', convDate, setGlobalFormV);
            setForAllNew('licenseEndDate', convDate, setFormV);
          }}
        />
      </BigInputDiv>
    </InputList>
  );
}
export default memo(LicenseGroup);
